import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ReactDOM from 'react-dom';
import ModalVideo from 'react-modal-video';
import UserLoginType from '../../../views/login/UserLoginType';
import Whatsapp from '../../../views/login/Whatsapp.js';

import ProductConfig from '../../../config/ProductConfig.json';
import HmAjax from '../../../util/HmAjax';
import PreLoginPage from '../../../views/core/PreLoginPage';
import Productbox from '../components/Productbox';
// ES6 class-style
class Banner extends PreLoginPage {

	constructor (props) {
		super(props);
		
	    this.state = {
		  isOpen: false
	    }
		this.openModal = this.openModal.bind(this);
		this.isFreeTrialAllowed = this.isFreeTrialAllowed.bind(this);
	  }

	  openModal () {
	    this.setState({isOpen: true})
	  }

	  homeforweb(){
		  return (
			<div className="slider-inner b-web-comp">
			<div  className="col-6 b-right">
				<div className="r-banner">
				<Productbox device={"web"} products_category_order={this.props.products_category_order} products_category={this.props.products_category} classes={this.props.classes} grades={this.props.grades} products_class={this.props.products_class}></Productbox>
					{/* <img src="../img/banner1.png" alt="" onClick={this.openModal}/>
					<a data-ga="Home  - Hey Parent Video" className="popup-modal" onClick={this.openModal}><span className="play-btn"></span></a> */}
				</div>
			</div>
			<div className="col-6 b-left">
			
				<h1 className="heading-one"><span className="txtcnt first-line">{this.rb("banner.heading")}</span> 
					<span className="hmorg">Hey</span>
					<span className="hmblue">Math! </span>
					<span className="txtcnt furtxt">{this.rb("banner.subheading")}</span>
				</h1>
				<h2 className="heading-two">
					<span className="wrdcls">{this.rb("banner.subheading1")}</span>
				</h2>
				
				{(() => {
					if(this.props.PLPloggedIn){ 
						if(this.isFreeTrialAllowed()){
							return(
							<div className="paddtri">
								<a href="#" data-ga="Home - Best Math Teacher - Free Trial" className="r-btn" onClick={this.props.startFreeTrial}>Start your Free Trial</a>
								<Whatsapp align="left" maxWidth="285px">/</Whatsapp>
							</div>
						);
						}else{
							return (<span></span>);
						}						
					}else{
						return(
								<div className="col-12 nopadding mx-auto joingrp">
									<UserLoginType showSignUp={this.props.showSignUp} showNewLoginForm={this.props.showNewLoginForm} from={"Top"}/>
									<Whatsapp align="left" maxWidth="100%">/</Whatsapp>
								</div>
						);
					}
				})()}

				<div className="clearfix"></div>
				<div>
				<ul className="nottxt">
					{/* <li>{this.rb("banner.points1")}</li>
					<li>{this.rb("banner.points2")}</li>
					<li>{this.rb("banner.points3")}</li> 
					<li>{this.rb("banner.points4")}<span>{this.rb("banner.price")}</span></li>*/}
				</ul>
				
			</div> 
				
			</div> 
			</div>
		  )
	  }

	  isFreeTrialAllowed(){
	  	let userRole = this.getUser().getRole();  
	  	if(userRole && userRole.length > 1 && window.noFreeTrialRoles && window.noFreeTrialRoles.length > 0){
	  		return  !(~window.noFreeTrialRoles.indexOf(userRole));
	  	}

	  	//user not logged in or role not defined latter is unlikely or no suppression in window.noFreeTrialRoles
	  	return true;
	  }

	  homeformobile(){

		return (
			<div className="comp-inner">
			
			<div className="col-12 text-center b-comp">
			
				<div>
				<div><span className="txtcnt">{this.rb("banner.heading")}</span></div> 
				<div>
					<span className="hmorg">Hey</span>
					<span className="hmblue">Math! </span>
					<span className="txtcnt furtxt">{this.rb("banner.subheading")}</span></div>
				</div>

				<div className="wrdcls">{this.rb("banner.subheading1")}</div>

				{(() => {
					if(this.props.PLPloggedIn){ 
						if(this.isFreeTrialAllowed()){
								return(
							<div className="paddtri">
								<a href="#" data-ga="Home - Best Math Teacher - Free Trial" className="r-btn" onClick={this.props.startFreeTrial}>Start your Free Trial</a>
								<Whatsapp align="center" background={"#30BDBD"} maxWidth="100%">/</Whatsapp>
							</div>
						);
						}else{
							return (<span></span>);
						}						
					}else{
						return(
								<div className="col-12 nopadding mx-auto joingrp">
									<UserLoginType showSignUp={this.props.showSignUp} showNewLoginForm={this.props.showNewLoginForm} from={"Top"}/>
									<Whatsapp align="center" background={"#30BDBD"} maxWidth="100%">/</Whatsapp>
								</div>
						);
					}
				})()}

				<div className="clearfix"></div>
				<div>
				<ul className="nottxt">
					{/* <li>{this.rb("banner.points1")}</li>
					<li>{this.rb("banner.points2")}</li>
					<li>{this.rb("banner.points3")}</li> 
					<li>{this.rb("banner.points4")}<span>{this.rb("banner.price")}</span></li>*/}
				</ul>
				
			</div> 
				
			</div> 

			<div  className="col-12">
				<div className="r-banner">
				<Productbox device={"mobile"} products_category_order={this.props.products_category_order} products_category={this.props.products_category} classes={this.props.classes} grades={this.props.grades} products_class={this.props.products_class}></Productbox>
					{/* <img src="../img/banner1.png" alt="" onClick={this.openModal}/>
					<a data-ga="Home  - Hey Parent Video" className="popup-modal" onClick={this.openModal}><span className="play-btn"></span></a> */}
				</div>
			</div>

			</div>
		  ) 
	  }

	homecomponent(){
		if(this.isMobile() || this.isTab()){
			return (
				<section className="h-mob-banner">  
					<div className="swiper-container home-banner"> 
						{/*<Swiper className="swiper-wrapper" pagination={params.pagination}>*/} 
							<div className="swiper-slide"> 
								<div className="container">
									{this.homeformobile()}
								</div>
								</div>
							
						{/*</Swiper>*/} 
						<div className="swiper-pagination"></div>
					</div>
					<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='b-X5TsIQG24' onClose={() => this.setState({isOpen: false})} />  
				</section>
			)
			
		}else{
			return(
				<section className="h-banner">  
					<div className="swiper-container home-bannerweb"> 
						{/*<Swiper className="swiper-wrapper" pagination={params.pagination}>*/} 
							<div className="swiper-slide"> 
								<div className="container">
									{this.homeforweb()}
								</div>
								</div>
							
						{/*</Swiper>*/} 
						<div className="swiper-pagination"></div>
					</div>
					<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='b-X5TsIQG24' onClose={() => this.setState({isOpen: false})} />  
				</section>

			)
		}
	}


  render() {
		console.log("plplogin:::"+this.props.PLPloggedIn);
  	const params = {
	 	pagination: {
	 		el: '.swiper-pagination', 
	 		clickable: true,
	 	}
	}
  	return this.homecomponent();
  }
}

/*ReactDOM.render(<Banner />, document.getElementById('root'));*/
export default Banner;



// WEBPACK FOOTER //
// ./src/prelogin/src/components/Banner.js